import { createRoutine } from 'redux-saga-routines'

import { Login, Logout, ME, update } from './constants'
import { ILoginState } from './index.interface'

export const loginUser = createRoutine(Login)
export const logoutUser = createRoutine(Logout)
export const loggedInUser = createRoutine(ME)
export const updateMe = createRoutine(update)
export const updateMeToken = createRoutine('UPDATE_ME_TOKEN')

const initialLoginState: ILoginState = {
  loading: false,
  error: false,
  success: false,
  message: '',
  token: '',
  user: {}
}

export default (state = initialLoginState, action: any) => {
  const { type = '', payload = {} as Partial<ILoginState> } = action

  switch (type) {
    case loginUser.TRIGGER:
      return {
        ...state,
        error: false,
        loading: true,
        success: false,
        message: '',
        user: initialLoginState.user
      }
    case loginUser.SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
        success: true,
        message: '',
        user: payload.user
      }
    case loginUser.FAILURE:
      return {
        ...state,
        error: true,
        loading: false,
        success: false,
        message: payload.message,
        user: initialLoginState.user
      }

    case logoutUser.TRIGGER:
      return {
        ...state,
        error: false,
        loading: true,
        success: false,
        message: ''
      }
    case logoutUser.SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
        success: false,
        message: '',
        token: '',
        me: {}
      }
    case logoutUser.FAILURE:
      return {
        ...state,
        error: false,
        loading: true,
        success: false
      }
    case updateMeToken.SUCCESS:
      return {
        ...state,
        token: payload.token
      }
    case updateMe.SUCCESS:
      let object = {
        ...state,

      }
      if (action.payload.id === state.user.id) {
        object = {
          ...state,
          user: {
            ...state.user,
            ...action.payload
          }
        }
      }
      return object

    default:
      return { ...state }
  }
}
